<template>
    <div>
        <form @submit.prevent="login" v-if="!completed">
            <fieldset :disabled="loading">
                <div class="form-group">
                    <label>{{translate('login.accountCode')}}</label>
                    <input v-model="loginData.AccountCode" type="text" class="form-control" aria-describedby="accountHelp" required />
                </div>
                <div class="form-group">
                    <label>{{translate('login.email')}}</label>
                    <input v-model="loginData.Email" type="email" class="form-control" required />
                </div>
                <!-- <div class="form-group">
                    <label>Kimlik No</label>
                    <input v-model="loginData.IdentityNumber" type="tel" class="form-control" required />
                </div> -->
                <div class="form-group">
                    <label>{{translate('login.validationCode')}}</label>
                    <div class="input-group input-group-lg">
                        <div class="input-group-prepend">
                            <span class="input-group-text captcha" :title="translate('login.validationCodeTitle')" ref="captcha" @click="refreshCaptcha()"></span>
                        </div>
                        <input v-model="loginData.Captcha" type="text" :placeholder="translate('login.validationCodeText')" class="form-control" required />
                    </div>
                </div>
                <button type="submit" class="btn btn-primary">{{translate('login.resetPassword')}}</button>
                <div v-if="errorMessage" class="text-danger">{{translate('login.error')}} {{errorMessage}}</div>
            </fieldset>
        </form>
        <div v-else>
            <h2 class="font-weight-bold" style="font-size: large;">{{translate('login.checkEmail')}} </h2>
            <div  class="alert alert-success">
                {{ successMessage }}
            </div>
            <h3 style="font-size: medium; font-weight: 600;">{{translate('login.didntGetEmail')}} </h3>
            <div class="alert alert-warning" style="font-size: small;">
                {{translate('login.checkSpam')}}  <br>
                {{translate('login.contactIfLDAP')}} 
            </div>
            <p class="text-right">
                <router-link to="/" class="btn btn-success">{{translate('okay')}}</router-link>
            </p>
        </div>
    </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'PasswordReset',
  props: {
    
  },
  data: () => ({
    loading: false,
    loginData: {
        AccountCode: window.settings.defaultAccountCode
    },
    errorMessage : null,
    completed: false,
    successMessage: null,
  }),
  created(){
      this.refreshCaptcha();
  },
  methods: {
    refreshCaptcha(){
        return axios.get('/passwordreset/captcha')
        .then(x => {
            this.$refs.captcha.style = `background-image: url('data:image/jpg;base64,${x.data.Data.base64image}')`;
            this.loginData.Identifier = x.data.Data.identifier;
            this.loginData.Captcha = '';
        })
        .catch(x => {
            this.$refs.captcha.style = "background-color:red";
            this.loginData.identifier = null;
            this.loginData.Captcha = '';
            console.warn('CAPTCHA yüklenemedi: ', x);
        })
    },
    login(){
        this.loading = true;
        axios.post('/passwordreset/createrequest', this.loginData)
        .then(x => {
            this.errorMessage = null;
            console.log("Gelen sonuç:", x);
            if(x.data.Success) {
                this.completed = true;
                this.successMessage = x.data.SuccessMessages;
            } else {
                this.errorMessage = x.data.ErrorMessages;
                this.refreshCaptcha().then(() => {
                    this.loading = false;
                });
            }
        }).catch(e => {
            console.log('Error:', e);
            if(e.response === undefined) {
                this.errorMessage = this.translate('errors.cantConnectError');
            } else {
                this.errorMessage = this.translate('errors.unexpectedError');
            }

            this.refreshCaptcha().then(() => {
                this.loading = false;
            });
        })

        
    }
  }
}
</script>
<style scoped>
.captcha {
    width:100px;
    background-repeat: no-repeat;
    background-position: center center;
    cursor: pointer;
}
</style>